import { TimelineOutcomeStatus } from 'features/timeline/types/outcomes';

export const TIMELINE_ITEM_TYPES = {
  BRIDGE_MODE: 'bridge_mode',
  SPRINT: 'sprint',
} as const;

export const DEFAULT_TOTAL_AMOUNT = 0;

// adding this for routines to work outside of the sprint
export const DEFAULT_WEEKS_COUNT = 1;
export const DEFAULT_WEEK_INDEX = 0;

export const WEEKLY_OUTCOME_STATUSES = {
  NOT_STARTED: 'not_started',
  STARTED: 'started',
  FAILED: 'failed',
  COMPLETED: 'completed',
} as const;

export const OUTCOME_STATUS_COLOR_MAP: Record<TimelineOutcomeStatus, string> = {
  [WEEKLY_OUTCOME_STATUSES.NOT_STARTED]: 'var(--gray300)',
  [WEEKLY_OUTCOME_STATUSES.STARTED]: 'var(--bgCompWarning)',
  [WEEKLY_OUTCOME_STATUSES.FAILED]: 'var(--bgCompDanger)',
  [WEEKLY_OUTCOME_STATUSES.COMPLETED]: 'var(--bgCompSuccess)',
};

export const OUTCOME_STATUS_LABELS: Record<TimelineOutcomeStatus, string> = {
  [WEEKLY_OUTCOME_STATUSES.NOT_STARTED]: 'Not Started',
  [WEEKLY_OUTCOME_STATUSES.STARTED]: 'Started',
  [WEEKLY_OUTCOME_STATUSES.FAILED]: 'Failed',
  [WEEKLY_OUTCOME_STATUSES.COMPLETED]: 'Complete',
};
